import { useState, useRef } from 'react';

const useSwipe = (onSwipeLeft, onSwipeRight, threshold = 50) => {
  const [isSwiping, setIsSwiping] = useState(false);
  const [swipeOffset, setSwipeOffset] = useState(0);
  const touchStart = useRef(null);
  const touchEnd = useRef(null);
  const currentOffset = useRef(0);

  const minSwipeDistance = threshold;

  const onTouchStart = (e) => {
    touchEnd.current = null;
    touchStart.current = e.targetTouches[0].clientX;
    setIsSwiping(true);
    currentOffset.current = 0;
  };

  const onTouchMove = (e) => {
    if (!touchStart.current) return;
    touchEnd.current = e.targetTouches[0].clientX;
    const offset = touchEnd.current - touchStart.current;
    currentOffset.current = offset;
    setSwipeOffset(offset);
  };

  const onTouchEnd = () => {
    if (!touchStart.current || !touchEnd.current) {
      setIsSwiping(false);
      setSwipeOffset(0);
      return;
    }

    const distance = touchStart.current - touchEnd.current;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe && onSwipeLeft) {
      onSwipeLeft();
    } else if (isRightSwipe && onSwipeRight) {
      onSwipeRight();
    }

    // Reset
    touchStart.current = null;
    touchEnd.current = null;
    setIsSwiping(false);
    setSwipeOffset(0);
    currentOffset.current = 0;
  };

  return {
    onTouchStart,
    onTouchMove,
    onTouchEnd,
    isSwiping,
    swipeOffset
  };
};

export default useSwipe;
